import axios from 'axios'
import jwtToken from './getJwtToken'

const paymentsApiUrl = process.env.VUE_APP_PAYMENTS_API_URL

export default axios.create({
  baseURL: `${paymentsApiUrl}/api`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
